import { Navigate, Outlet } from "react-router-dom";
import { getAuth } from "../components/utils/auth";
import useIdle from "../components/utils/sessionTimeout";

export default () => {
  const isIdle = useIdle();
  const user = getAuth();

  return user ? <Outlet /> : <Navigate to="/admin/login" />;
};
